export default __webpack_public_path__ + "static/media/repo_course_structure.5e903941.png";